import { Axis, Chart, Coordinate, Interaction, Interval, Tooltip } from 'bizcharts'
import numeral from 'numeral'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { ShowBusy } from '../Reducers/InicioReducer';
import { InicioMobileAsync } from '../Servicios/ServiciosPublicos';



export const GraficaSaldo = () => {
    //#region hooks
    const dispatch = useDispatch();
    //#endregion

    //#region internalState
    const [internalState, setInternalState] = useState({
        Load: false,
        InicioMobile: {
            Saldo: 0,
            Detalle: []
        },
    })
    //#endregion
    //#region useEffect
    useEffect(() => {
        Load();
        const _objInt = setInterval(() => { ObtenerInicioMobile(); }, 10000);
        return () => { console.log("kill interval"); if (_objInt) { clearInterval(_objInt); } };
    }, []);
    //#endregion
    //#region Metodos
    const Load = async () => {
        await ObtenerInicioMobile();
    }
    const ObtenerInicioMobile = async (showBusy = false) => {
        if (showBusy) { dispatch(ShowBusy()); }
        let inicio = await InicioMobileAsync();
        dispatch(ShowBusy(false));
        setInternalState((state) => { return { ...state, InicioMobile: inicio, Load: true } });
    }
    //#endregion


    return (<>
        <div style={{ minWidth: "100%", width: "70%", position: "relative", height: "500px" }}>
            {+internalState.InicioMobile.Saldo > 0 && (<div className="saldo-render">{numeral(internalState.InicioMobile.Saldo).format("0,000.00")}</div>)}
            <Chart data={internalState.InicioMobile.Detalle} height={500} autoFit >
                <Coordinate type="theta" radius={0.8} innerRadius={0.75} />
                <Axis visible={false} />
                <Tooltip showTitle={false} />
                <Interval
                    adjust="stack"
                    position="TotalMXN"
                    color="Nombre"
                    shape="sliceShape"
                />
                <Interaction type="element-single-selected" />
            </Chart>
        </div>
    </>)
}
